import { Link } from 'react-router-dom';
import { CreditCard } from 'lucide-react';

type BrandLogoProps = {
  to?: string;
  size?: 'sm' | 'md' | 'lg';
  /** dark: 白字（用于深色背景） */
  variant?: 'light' | 'dark';
  showWordmark?: boolean;
  className?: string;
};

const sizeMap = {
  sm: { box: 'w-8 h-8 rounded-lg', icon: 'w-4 h-4', text: 'text-base' },
  md: { box: 'w-9 h-9 rounded-xl', icon: 'w-5 h-5', text: 'text-lg' },
  lg: { box: 'w-11 h-11 rounded-xl', icon: 'w-5 h-5', text: 'text-2xl' },
};

/** Allinks 品牌标识 —— 全端一致，禁止 CardPlatform 等旧名 */
export function BrandLogo({
  to,
  size = 'md',
  variant = 'light',
  showWordmark = true,
  className = '',
}: BrandLogoProps) {
  const s = sizeMap[size];
  const word =
    variant === 'dark'
      ? 'text-white font-bold tracking-tight'
      : 'text-slate-900 font-bold tracking-tight';

  const inner = (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <span
        className={`${s.box} bg-brand-gradient flex items-center justify-center shadow-sm shrink-0`}
      >
        <CreditCard className={`${s.icon} text-white`} strokeWidth={2.25} />
      </span>
      {showWordmark && <span className={`${s.text} ${word}`}>Allinks</span>}
    </span>
  );

  if (to) {
    return (
      <Link to={to} className="inline-flex focus-visible:rounded-lg">
        {inner}
      </Link>
    );
  }
  return inner;
}
